<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PrintOptions from "@/components/modals/print-options.vue";
export default {
  page: {
    title: "Approved OPRCS",
  },
  components: {
    Layout,
    PageHeader,
    PrintOptions,
  },
  data() {
    return {
      title: "Approved Budget",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Approved Budget",
          active: true,
        },
      ],
      perPage: 10,
      filter: "",
      filterOn: [],
      sortDesc: false,
      pageOptions: [10, 25, 50, 100],
      currentPage: 1,
      totalRows: 1,
      isExternal: this.$store.state.data.selectedCampus.isExternal,
      fields: [
        {
          key: "title",
        },
        {
          key: "deliveryunit",
          label: "DeliveryUnit",
        },
        {
          key: "action",
          label: "",
        },
      ],
      cycle: Number(this.$store.getters["data/getCycle"]),
      selectedCampus: this.$store.state.data.selectedCampus.id,
      postedOpcr: [],
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    changeCycle(cycle) {
      this.cycle = cycle;
      this.$store.commit("data/changeCycle", cycle);
      this.fetchPostedOPCR();
    },
    changeCampus(campus) {
      this.selectedCampus = campus.id;
      this.fetchPostedOPCR();
    },
    fetchPostedOPCR() {
      this.$store.commit("opcr/SET_IS_POSTED_OPCR_LOADING", true);
      this.$store
        .dispatch("opcr/getPostedOpcr", {
          campusId: this.selectedCampus,
          cycle: this.cycle,
        })
        .then((response) => {
          if (response.data.error) {
            this.$store.commit("opcr/SET_IS_POSTED_OPCR_LOADING", false);
            return this.showToast(response.data.errorMessage);
          }
          this.postedOpcr = response.data;
          console.log(this.postedOpcr);
          this.totalRows = this.postedOpcr.length;
          this.$store.commit("opcr/SET_IS_POSTED_OPCR_LOADING", false);
        })
        .catch((error) => {
          this.$store.commit("opcr/SET_IS_POSTED_OPCR_LOADING", false);
          this.showToast("Something went wrong - Cannot fetch posted OPCrs");
        });
    },
    printPPMP(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/My/PPMP/OPCR",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    printOPCR(data) {
      /** Internal */
      if (this.isExternal) {
        this.$refs.printOpt.putOptions({
          apiUrl: "/api/Report/PrePlanning/WFP",
          routeVariables: [data],
        });
      } else {
        this.$refs.printOpt.putOptions({
          apiUrl: "api/Report/Planning/DU/OPCR",
          routeVariables: [data],
        });
      }
      this.$bvModal.show("print-options-modal");
    },
    printLIB(data) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Planning/LIB/OPCR",
        routeVariables: [data],
      });
      this.$bvModal.show("print-options-modal");
    },
  },
  created() {
    this.fetchPostedOPCR();
  },
};
</script>

<template>
  <Layout @changeCycle="changeCycle" @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <div>
      <div class="row">
        <div class="col-md-9 mb-md-0 mb-2">
          <div
            id="tickets-table_filter"
            class="dataTables_filter me-1 d-inline-block"
          >
            <label class="d-inline-flex align-items-center mb-0">
              <b-form-input
                autocomplete="off"
                v-model="filter"
                type="search"
                placeholder="Search service..."
                class="form-control"
              ></b-form-input>
            </label>
          </div>
          <div
            id="tickets-table_length"
            class="dataTables_length d-inline-block"
          >
            <label class="d-inline-flex align-items-center mb-0">
              <b-form-select
                class="form-select"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <b-table
              class="table project-list-table align-middle table-borderless"
              :items="postedOpcr"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :busy="$store.state.opcr.isPostedOpcrLoading"
              @filtered="onFiltered"
              show-empty
            >
              <template #empty="scope">
                <div class="text-center">
                  <h5 class="text-secondary">{{ scope.emptyText }}</h5>
                </div>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(deliveryunit)="row">
                <span class="text-light">{{
                  row.item.deliveryUnit
                    ? row.item.deliveryUnit.name
                    : "Not Indicated"
                }}</span>
              </template>
              <template #cell(action)="row">
                <!-- <span
                  class="text-info hoverable-link"
                  role="button"
                  @click="printPPMP(row.item.id)"
                  >[Print PPMP]</span
                > -->
                <b-button
                  variant="purple"
                  class="me-2"
                  size="sm"
                  :id="`popover-target-${row.item.id}`"
                >
                  <i class="bx bx-printer align-middle me-2 font-size-16"></i>
                  <span>Reports</span>
                </b-button>
                <b-popover
                  :target="`popover-target-${row.item.id}`"
                  triggers="hover blur"
                  placement="leftbottom"
                  variant="secondary"
                  custom-class="p-0 p-custom-class"
                >
                  <b-list-group class="w-100 fit">
                    <b-list-group-item
                      button
                      action
                      @click="printPPMP(row.item.id)"
                    >
                      <i class="bx bx-file align-middle me-2 font-size-16"></i
                      ><span class="align-middle">Print PPMP</span>
                    </b-list-group-item>

                    <b-list-group-item
                      button
                      action
                      @click="printOPCR(row.item.id)"
                    >
                      <i class="bx bx-file align-middle me-2 font-size-16"></i
                      ><span class="align-middle"
                        >Print {{ isExternal ? "WFP" : "OPCR" }}</span
                      >
                    </b-list-group-item>

                    <b-list-group-item
                      button
                      action
                      @click="printLIB(row.item.id)"
                    >
                      <i class="bx bx-file align-middle me-2 font-size-16"></i
                      ><span class="align-middle">Print LIB</span>
                    </b-list-group-item>
                  </b-list-group>
                </b-popover>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>
<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>
